import { useLingui } from '@lingui/react/macro';
import type { FC } from 'react';
import { useHasAccessToken } from '@/auth/api';
import { useLocation } from '@/base/router';
import { Banner } from '@/shared/Banner';
import { useMe } from '../profile/api';
import { useIdentificationSteps } from './useIdentificationSteps';

export const IdentificationBanner: FC<{
  className?: string;
  minStep?: number;
}> = ({ className, minStep }) => {
  const me = useMe();
  const { t } = useLingui();
  const hasAccessToken = useHasAccessToken();
  const [, navigate] = useLocation();
  const steps = useIdentificationSteps().slice(0, minStep);
  const needAction = steps.some((x) => x.needAction);
  const done = steps.every((x) => x.status === 'completed');
  if (done || !hasAccessToken || me.isLoading) return null;

  return (
    <Banner
      variant={needAction ? 'negative' : 'notice'}
      className={className}
      onClick={() => navigate('app', '/account/identification')}
    >
      {needAction
        ? t`Complete your profile to fulfill verification requirements and unlock all features.`
        : t`Your verification is under review. You’ll be notified once it’s approved.`}
    </Banner>
  );
};
